<template>
  <div>
    <router-view/>
  </div>
</template>
<style>
@import "@/assets/toast.css";
</style>